// extracted by mini-css-extract-plugin
module.exports = {"PowerHub":"PowerHub_PowerHub__T3t_e"};